import { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  Avatar,
  Stack,
  Typography,
  Modal,
  Box,
  Chip,
  Card,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { Close as CloseIcon, MoreVert, ChatBubble } from "@mui/icons-material";
import defaultUserProfilePic from "../../assets/images/avtar_placeholder.jpeg";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Carousel } from "react-responsive-carousel";
import { GET_USER_DASHBOARD, SAVE_CHAT_GROUP_USERS } from "../../constant/Apipath.jsx";
import { Getrequestcall } from "../../request/Getrequest.jsx";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback.jsx";
import PictureViewer from "../../common/PictureViewer.jsx";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader.jsx";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { useDispatch } from "react-redux";
import { setChatState, setShowReport, setReportSuccess } from "../../redux/actions/actions.jsx";

const ItemDetailsModal = (props) => {
  const { item } = props;
  const { loginData, reportSuccess, multiLanguageData } = useSelector((state) => state?.main);

  // Language data
  const LanguageData = multiLanguageData?.BuySell || {};
  const {
    TEXT_ITEM_DETAILS_HEADER = English.BuySell.TEXT_ITEM_DETAILS_HEADER,
    TEXT_FOR_TRADE_BADGE = English.BuySell.TEXT_FOR_TRADE_BADGE,
    TEXT_OPEN_FOR_TRADE = English.BuySell.TEXT_OPEN_FOR_TRADE,
    TEXT_INDIVIDUAL_SELLER = English.BuySell.TEXT_INDIVIDUAL_SELLER,
    TEXT_DESCRIPTION_SECTION = English.BuySell.TEXT_DESCRIPTION_SECTION,
    TEXT_LOCATION_SECTION = English.BuySell.TEXT_LOCATION_SECTION,
    TEXT_KMS_AWAY = English.BuySell.TEXT_KMS_AWAY,
    TEXT_MESSAGE_SELLER_BTN = English.BuySell.TEXT_MESSAGE_SELLER_BTN,
    TEXT_REPORT_ITEM = English.BuySell.TEXT_REPORT_ITEM,
    TEXT_EMAIL = English.BuySell.TEXT_EMAIL,
    TEXT_PHONE = English.BuySell.TEXT_PHONE,
    TEXT_CHAT = English.BuySell.TEXT_CHAT,
    TEXT_SELECT_CONTACT_METHOD_TITLE = English.BuySell.TEXT_SELECT_CONTACT_METHOD_TITLE,
    TEXT_SELECT_CONTACT_METHOD_SUBTITLE = English.BuySell.TEXT_SELECT_CONTACT_METHOD_SUBTITLE,
    TEXT_RENTED_TAG = English.BuySell.TEXT_RENTED_TAG
  } = LanguageData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState(null);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewIndex, setPictureViewIndex] = useState(0);
  const [IsLoading, setIsLoading] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [contactOptionsOpen, setContactOptionsOpen] = useState(false);

  const containerStyle = {
    width: "100%",
    height: "250px",
    borderRadius: "12px",
    overflow: "hidden",
    marginTop: "16px"
  };

  useEffect(() => {
    if (item) {
      getUserDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  useEffect(() => {
    if (reportSuccess) {
      dispatch(setReportSuccess(false));
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportSuccess]);

  const getUserDetails = async () => {
    try {
      setIsLoading(true);
      let res = await Getrequestcall(
        `${GET_USER_DASHBOARD}/${item?.userId}`,
        loginData?.accessToken
      );
      setUserDetails(res?.data?.data ?? null);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("getUserDetails -> Error while getting user details :: ", error);
    }
  };

  const onClose = () => {
    setUserDetails(null);
    setPictureViewIndex(0);
    setPictureViewerOpen(false);
    setContactOptionsOpen(false);
    props?.onClose();
  };

  const getSellerEmail = () => {
    return (
      userDetails?.email ||
      userDetails?.userEmail ||
      userDetails?.contactEmail ||
      item?.email ||
      item?.userEmail ||
      item?.contactEmail ||
      ""
    );
  };

  const getSellerPhone = () => {
    return (
      userDetails?.phoneNumber ||
      userDetails?.phoneNo ||
      userDetails?.mobile ||
      item?.phone ||
      item?.phoneNumber ||
      item?.contactPhone ||
      ""
    );
  };

  const getListingSummary = () => {
    if (item?.statusName === "For Rent") {
      return {
        from2: "For Rent",
        message: `Hi, I'm interested in your rental property "${item?.title}". Could you provide more details?`
      };
    }
    if (item?.forTrade) {
      return {
        from2: "For Trade",
        message: `Hi, I'm interested in trading for "${item?.title}".`
      };
    }
    return {
      from2: `$${item?.price?.toLocaleString() || "0"}`,
      message: `Hi, I'm interested in buying "${item?.title}".`
    };
  };

  const getEmailSubjectAndBody = () => {
    const sellerUserName = `${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`.trim();
    if (item?.statusName === "For Rent") {
      return {
        subject: `Inquiry about your rental: ${item?.title}`,
        body: `Hi ${sellerUserName || ""}, am interested in learning more about your rental property "${item?.title}". Could you please provide additional details? Thanks!`
      };
    }
    return {
      subject: `Inquiry about your listing: ${item?.title}`,
      body: `Hi ${sellerUserName || ""}, am interested in your listing "${item?.title}". Please let me know if it's still available. Thanks!`
    };
  };

  const handleOpenChat = async (defaultMessage) => {
    try {
      setIsLoading(true);
      const getRequest = [
        {
          Id: 0,
          ChatGroupId: 0,
          UserId: Number(item?.userId),
          ModifiedBy: Number(loginData?.userInformation?.UserId),
          Muted: false
        }
      ];

      const chatGroupObj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: getRequest
      };

      const getResponse = await Postrequestcall(
        SAVE_CHAT_GROUP_USERS,
        chatGroupObj,
        loginData?.accessToken
      );

      if (getResponse?.status === 201) {
        const getChatgroupId = getResponse?.data?.data[0]?.objData?.chatGroupId;
        const chatState = {
          chatGroupId: getChatgroupId,
          from: "newChat",
          refresh: new Date().getTime(),
          defaultMessage: defaultMessage || ""
        };
        dispatch(setChatState(chatState));
        navigate("/chat");
      }
    } catch (error) {
      console.error("Error creating chat group:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const openEmailClient = () => {
    const email = getSellerEmail();
    if (!email) {
      alert("Seller email is not available.");
      return;
    }

    const { subject, body } = getEmailSubjectAndBody();
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const openPhoneDialer = () => {
    const phone = getSellerPhone();
    if (!phone) {
      alert("Seller phone number is not available.");
      return;
    }
    const formattedPhone = phone.toString().replace(/[^+0-9]/g, "");
    window.location.href = `tel:${formattedPhone}`;
  };

  const handleContactMethod = async (method) => {
    setContactOptionsOpen(false);
    if (method === "email") {
      openEmailClient();
    } else if (method === "phone") {
      openPhoneDialer();
    } else {
      const { message } = getListingSummary();
      await handleOpenChat(message);
    }
  };

  const handleContactClick = async () => {
    if (item?.isFixedAsset) {
      const contactMethods = [];
      if (item?.contactByEmail) contactMethods.push("email");
      if (item?.contactByPhone) contactMethods.push("phone");
      if (item?.contactByChat) contactMethods.push("chat");

      if (contactMethods.length === 1) {
        await handleContactMethod(contactMethods[0]);
        return;
      }

      if (contactMethods.length > 1) {
        setContactOptionsOpen(true);
        return;
      }
    }

    await handleOpenChat();
  };

  const onImagePreview = (index) => {
    setPictureViewerOpen(true);
    setPictureViewIndex(index);
  };

  const getAddress = (params) => {
    const uAddress = getFormattedAddress(
      params?.address ?? "",
      params?.address1 ?? "",
      params?.city ?? "",
      params?.province ?? "",
      params?.country ?? "",
      params?.postalCode ?? "",
      3
    );
    return uAddress;
  };

  const handleViewReport = () => {
    let reportObj = {
      showReport: true,
      name: "Buy_and_Sell",
      recordId: item?.Id || item?.id || 0,
      AppScreenId: 384
    };
    dispatch(setShowReport(reportObj));
    setMoreMenuAnchorEl(null);
  };

  return (
    <>
      <Modal
        open={props.open}
        onClose={onClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2
        }}>
        <Box
          className="user-modal-responsive"
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "min(600px, calc(100vw - 32px))",
            maxHeight: "calc(100vh - 32px)",
            borderRadius: "24px",
            p: 0,
            overflow: "hidden",
            bgcolor: "white",
            maxWidth: "600px !important"
          }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              borderBottom: "1px solid #f1f5f9"
            }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {TEXT_ITEM_DETAILS_HEADER}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton onClick={(e) => setMoreMenuAnchorEl(e.currentTarget)} size="small">
                <MoreVert />
              </IconButton>
              <IconButton onClick={onClose} size="small">
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>

          {IsLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                flex: 1,
                minHeight: 0,
              }}>
              <Loader />
            </Box>
          ) : (
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overscrollBehavior: "contain",
            scrollbarWidth:'none',
                p: 0
              }}>
              {/* Image Carousel */}
              {item?.pictureList?.length > 0 && (
                <Box sx={{ bgcolor: "#f8fafc" }}>
                  <Carousel
                    showThumbs={false}
                    showStatus={false}
                    infiniteLoop
                    showIndicators={item?.pictureList?.length > 1}>
                    {item?.pictureList?.map((picture, index) => (
                      <div
                        key={index}
                        style={{ height: "300px", cursor: "zoom-in" }}
                        onClick={() => onImagePreview(index)}>
                        <img
                          src={picture.name}
                          alt={item?.title}
                          style={{ height: "100%", objectFit: "contain" }}
                        />
                      </div>
                    ))}
                  </Carousel>
                </Box>
              )}

              <Box sx={{ p: 3 }}>
                {/* Title and Price */}
                <Stack spacing={1} sx={{ mb: 3 }}>
                  <Stack sx={{ justifyContent: "space-between", alignItems: "flex-start" }} direction="row">
                    <Typography variant="h5" sx={{color: "#1e293b",  fontWeight: 700 }} >
                      {item?.title}
                    </Typography>
                    <Typography variant="h5" sx={{color: "#3b82f6",  fontWeight: 800 }} >
                      {item.forTrade ? TEXT_FOR_TRADE_BADGE : `$${item?.price?.toLocaleString()}`}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {item.forTrade && (
                      <Chip
                        label={TEXT_OPEN_FOR_TRADE}
                        size="small"
                        sx={{
                          width: "fit-content",
                          bgcolor: "#eff6ff",
                          color: "#3b82f6",
                          fontWeight: 600
                        }}
                      />
                    )}
                    {item?.statusName === "For Rent" && (
                      <Chip
                        label={TEXT_RENTED_TAG}
                        size="small"
                        sx={{
                          width: "fit-content",
                          bgcolor: "#ede9fe",
                          color: "#5b21b6",
                          fontWeight: 600
                        }}
                      />
                    )}
                  </Stack>
                </Stack>

                {/* Seller Info */}
                <Card
                  elevation={0}
                  sx={{
                    bgcolor: "#f8fafc",
                    borderRadius: "16px",
                    mb: 3,
                    border: "1px solid #f1f5f9",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#f1f5f9" }
                  }}
                  onClick={() => navigate(`/${item?.userId}`)}>
                  <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar
                      src={userDetails?.pictureUrl || defaultUserProfilePic}
                      sx={{ width: 48, height: 48, border: "2px solid white" }}
                    />
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {userDetails?.firstName} {userDetails?.lastName}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {userDetails?.tradeName || TEXT_INDIVIDUAL_SELLER}
                      </Typography>
                    </Box>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleContactClick();
                      }}
                      sx={{
                        bgcolor: "#eff6ff",
                        color: "#3b82f6",
                        "&:hover": { bgcolor: "#dbeafe" }
                      }}>
                      <ChatBubble />
                    </IconButton>
                  </Box>
                </Card>

                {/* Description */}
                {item?.description && (
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{color: "text.secondary",  fontWeight: 700 }}
                      
                      gutterBottom>
                      {TEXT_DESCRIPTION_SECTION}
                    </Typography>
                    <Typography variant="body1"  sx={{color: "#475569",  whiteSpace: "pre-line" }}>
                      {item?.description}
                    </Typography>
                  </Box>
                )}

                {/* Location */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{color: "text.secondary",  fontWeight: 700 }}
                    
                    gutterBottom>
                    {TEXT_LOCATION_SECTION}
                  </Typography>
                  <Stack direction="row" spacing={1} sx={{ mb: 1,  alignItems: "center" }} >
                    <FmdGoodIcon sx={{ color: "#3b82f6" }} />
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {item?.siteName}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      ({item?.distance?.toFixed(1)} {TEXT_KMS_AWAY})
                    </Typography>
                  </Stack>
                  <Typography variant="body2" sx={{ pl: 4,  color: "text.secondary" }} >
                    {getAddress(item)}
                  </Typography>

                  <GoogleMap
                    options={{
                      disableDefaultUI: true,
                      zoomControl: false,
                      styles: [{ featureType: "poi", stylers: [{ visibility: "off" }] }]
                    }}
                    center={{ lat: item?.latitude, lng: item?.longitude }}
                    zoom={13}
                    mapContainerStyle={containerStyle}>
                    <Marker
                      position={{ lat: item?.latitude, lng: item?.longitude }}
                      icon={{
                        url: mapMarkerYellow,
                        scaledSize: new window.google.maps.Size(30, 40)
                      }}
                    />
                  </GoogleMap>
                </Box>

                <Button
                  onClick={handleContactClick}
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    borderRadius: "12px",
                    py: 1.5,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#3b82f6",
                    "&:hover": { bgcolor: "#2563eb" }
                  }}>
                  {TEXT_MESSAGE_SELLER_BTN}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Modal>

      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={item?.pictureList?.map((pic) => ({ src: pic.name, alt: "" }))}
          viewerIndex={pictureViewIndex}
        />
      )}

      <Menu
        anchorEl={moreMenuAnchorEl}
        open={Boolean(moreMenuAnchorEl)}
        onClose={() => setMoreMenuAnchorEl(null)}
        PaperProps={{ sx: { borderRadius: "12px", mt: 1 } }}>
        <MenuItem onClick={handleViewReport} sx={{ color: "#ef4444" }}>
          {TEXT_REPORT_ITEM}
        </MenuItem>
      </Menu>

      <Dialog open={contactOptionsOpen} onClose={() => setContactOptionsOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{TEXT_SELECT_CONTACT_METHOD_TITLE || "Contact Seller"}</DialogTitle>
        <DialogContent>
          <Typography variant="body2"  sx={{color: "text.secondary",  mb: 2 }}>
            {TEXT_SELECT_CONTACT_METHOD_SUBTITLE || "Choose how you want to contact the seller."}
          </Typography>
          <Stack spacing={1}>
            {item?.contactByEmail && (
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleContactMethod("email")}
                disabled={!getSellerEmail()}>
                {TEXT_EMAIL}
              </Button>
            )}
            {item?.contactByPhone && (
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleContactMethod("phone")}
                disabled={!getSellerPhone()}>
                {TEXT_PHONE}
              </Button>
            )}
            {item?.contactByChat && (
              <Button fullWidth variant="outlined" onClick={() => handleContactMethod("chat")}>{TEXT_CHAT}</Button>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactOptionsOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ItemDetailsModal;
